import { Check } from 'lucide-react';

export interface ThemeTileProps {
  readonly id: string;
  readonly label: string;
  readonly previewSrc: string;
  readonly selected: boolean;
  readonly onClick: () => void;
  readonly className?: string;
}

export function ThemeTile({ id, label, previewSrc, selected, onClick, className = '' }: ThemeTileProps) {
  return (
    <button
      type="button"
      // biome-ignore lint/a11y/useSemanticElements: visual design requires button styling + keyboard activation; radio role is correct inside a role="radiogroup" parent (ThemePicker)
      role="radio"
      aria-checked={selected}
      aria-label={`Theme: ${label}`}
      data-testid={`theme-tile-${id}`}
      onClick={onClick}
      className={`relative flex h-16 w-24 flex-col items-center justify-end gap-1 overflow-hidden rounded-2xl border-2 border-transparent bg-cream transition-all hover:brightness-105 active:scale-95 ${
        selected ? 'ring-2 ring-berry' : ''
      } ${className}`}
    >
      <img src={previewSrc} alt="" className="absolute inset-0 h-full w-full object-cover" />
      <span className="relative z-10 rounded bg-ink/70 px-1.5 py-0.5 text-xs font-bold text-cream">{label}</span>
      {selected && (
        <span
          data-testid={`theme-tile-check-${id}`}
          className="absolute right-1 top-1 z-10 inline-flex h-5 w-5 items-center justify-center rounded-full bg-berry text-cream"
          aria-hidden
        >
          <Check className="h-3 w-3" />
        </span>
      )}
    </button>
  );
}
